import React from "react";
import "react-step-progress-bar/styles.css";
import { ProgressBar } from "react-step-progress-bar";

export default function HorizontalProgressBar({ percent }) {
  return (
    <ProgressBar
      percent={percent}
      filledBackground="#022444"
      unfilledBackground="#F1F9FF"
    />
  );
}
